import { emitter } from '@/emitter'
import Toastify from 'toastify-js'

emitter.on('toastify', ({ text, type = 'info', duration = 5000 }) => {
    const toastify = Toastify({
        type: `toastify--${['info', 'success', 'error'].includes(type) ? type : 'info'}`,
        text,
        duration
    })

    toastify.showToast()
})